import React, {useEffect} from "react";
import { useLocation } from "react-router-dom";
import { loadWasm } from "../wasm-loader.js";

export default function BevyGraphs() {
   const location = useLocation();

    useEffect(() => {
        window.get_window_size = () => {
            return {
                width: window.innerWidth,
                height: window.innerHeight
            }
        }

        const initGame = async () => {
            try {
                const wasm = await loadWasm();
                wasm.run_app();
                console.log("called wasm.run_app()");
            } catch (err) {
                console.error("Failed to load bevy graphs: ", err);
           }
        }
        initGame();

        return () => {
            console.log("cleaning up wasm");
        }
    }, [location]);
    return (
        <div className="flex justify-center items-center h-screen">
            <canvas id="bevy_graph_simulator_canvas" width="1280" height="720" className="border border-gray-300"/>
        </div>
    )
}